// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"SkeletonView_loadingContainer__1r2bb","loadingText":"SkeletonView_loadingText__2IsBw"};